var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIrrigationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    fill: "#4A90E2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 15,
    width: 19,
    height: 3,
    rx: 1.5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.25,
    y: 18,
    width: 1.5,
    height: 8,
    rx: 0.75,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.75,
    y: 18,
    width: 1.5,
    height: 8,
    rx: 0.75,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.25,
    y: 18,
    width: 1.5,
    height: 8,
    rx: 0.75,
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 20,
    r: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 20,
    r: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 20,
    r: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 22.5,
    r: 0.4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 22.5,
    r: 0.4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 22.5,
    r: 0.4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 26 Q10 24 11 26 Q12 24 13 26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 26 Q15.5 24 16.5 26 Q17.5 24 18.5 26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 26 Q21 24 22 26 Q23 24 24 26"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 16.5,
    r: 1.5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 16.5 L7 16.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 16.5 L15 16.5 M14.25 15.75 L15 16.5 L14.25 17.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 16.5 L20 16.5 M19.25 15.75 L20 16.5 L19.25 17.25"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIrrigationIcon);
export default __webpack_public_path__ + "static/media/irrigation_icon.c843dc16b51087f11918224c9ac154da.svg";
export { ForwardRef as ReactComponent };